import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['Valentina', 'Matías', 'Lucía', 'Sebastián', 'Camila', 'Diego', 'Florencia', 'Ramiro', 'Agustina', 'Nicolás'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialDelay = Math.random() * (25000 - 15000) + 15000;
    const initialTimer = setTimeout(showPopup, initialDelay);
    // Recurring interval
    const interval = setInterval(() => {
      const delay = Math.random() * (25000 - 15000) + 15000;
      setTimeout(showPopup, delay);
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-in" data-id="element-337">
      <div className="bg-white rounded-lg shadow-2xl p-4 pr-12 max-w-sm border-l-4 border-green-500" data-id="element-338">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar notificación" data-id="element-339">
          <XIcon className="h-4 w-4" data-id="element-340" />
        </button>
        <div className="flex items-start gap-3" data-id="element-341">
          <CheckCircleIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-342" />
          <div data-id="element-343">
            <p className="text-sm font-semibold text-gray-900" data-id="element-344">
              {currentName} de {currentCity}
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-345">
              acaba de comprar este libro digital ✅
            </p>
          </div>
        </div>
      </div>
    </div>;
}